<template>
  <div>
    <nav class="tab-menu">
      <!-- TKP-91: metin üretimi tek ekranlı sihirbaza taşındı; eski sekmeler geriye uyumluluk için yerinde -->
      <div v-if="canGenerate" :class="{ active: tabFilter === 'wizard' }" @click="tabFilter = 'wizard'" data-test="wizard-tab">
        {{ $t("legal-document-wizard.tab") }}
      </div>
      <div v-if="hasViewTemplatePermission" :class="{ active: tabFilter === 'template' }" @click="tabFilter = 'template'">
        {{ $t("legal-document-template.plural") }}
      </div>
      <div v-if="hasViewTemplatePermission" :class="{ active: tabFilter === 'review' }" @click="tabFilter = 'review'">{{ $t("legal-document-template.waiting-review") }}</div>
      <div v-if="hasViewDocumentPermission" :class="{ active: tabFilter === 'document' }" @click="tabFilter = 'document'">
        {{ $t("legal-document.plural") }}
      </div>
    </nav>
    <LegalDocumentWizard v-if="tabFilter == 'wizard' && canGenerate" product="GDPR" />
    <LegalDocumentTemplateView v-if="tabFilter == 'template'" product="GDPR" />
    <LegalDocumentReviewView v-if="tabFilter == 'review'" product="GDPR" />
    <LegalDocumentView v-if="tabFilter == 'document'" product="GDPR" />
  </div>
</template>

<script>
import LegalDocumentTemplateView from "./legal-document-template-view";
import LegalDocumentWizard from "./legal-document-wizard";
import LegalDocumentReviewView from "./legal-document-review-view";
import LegalDocumentView from "./legal-document-view";
import { firstVisibleTab } from "./legal-document-tabs"; // TKP-185 md.78

export default {
  components: { LegalDocumentTemplateView, LegalDocumentView, LegalDocumentReviewView, LegalDocumentWizard },
  // TKP-185 md.78: store'daki sekme kullanıcıya görünmüyorsa (Birim / Süreç Yöneticisi yalnız sihirbazı görür) görünür ilk sekmeye geç
  mounted() {
    const tab = firstVisibleTab(this.tabFilter, { document: this.hasViewDocumentPermission, wizard: this.canGenerate, template: this.hasViewTemplatePermission, review: this.hasViewTemplatePermission });
    if (tab && tab !== this.tabFilter) this.tabFilter = tab;
  },
  computed: {
    /** TKP-91: sihirbazda metin üretme yetkisi (dokümandaki "hukuk yöneticisi"). */
    canGenerate() {
      return this.currentAccountCan("LEGAL_DOCUMENT_WIZARD__CAN_GENERATE");
    },
    tabFilter: {
      get() {
        return this.$store.getters["organizationLegalDocument/tab"];
      },
      set(tab) {
        this.$store.commit("organizationLegalDocument/tab", tab);
      },
    },

    hasViewTemplatePermission() {
      if (this.currentAccountCan("LEGAL_DOCUMENT_GDPR_LEGAL_DOCUMENT_TEMPLATE_VIEW__HAS_VIEW_TEMPLATE_PERMISSION")) {
        return true;
      }

      return false;
    },

    hasViewDocumentPermission() {
      if (this.currentAccountCan("LEGAL_DOCUMENT_GDPR_LEGAL_DOCUMENT_TEMPLATE_VIEW__HAS_VIEW_DOCUMENT_PERMISSION")) {
        return true;
      }

      return false;
    },
  },
};
</script>
